var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('observaciones',{attrs:{"listPath":_vm.listPath,"createPath":_vm.createPath,"editPath":_vm.editPath,"canEdit":_vm.canEdit,"payloadId":"cuota","id":_vm.cuotaId}})}
var staticRenderFns = []

export { render, staticRenderFns }